import { user } from 'utils/auth/user';
import { sendApiRequest } from '.';
import { ISessionData } from 'data/schema';

/**
 * Get all scheduled sessions for the authenticated dealer
 */
export async function getScheduledSessions(): Promise<ISessionData[]> {
  const response = await sendApiRequest<ISessionData[]>(
    '/schedule',
    {
      method: 'GET',
      headers: {
        'X-User': user.userPseudonym,
        'X-Dealer': user.dealerId,
      },
    },
    true
  );

  return response || [];
}

/**
 * Create a new scheduled session
 */
export async function createScheduledSession(data: Omit<ISessionData, 'id' | 'dealerId'>): Promise<ISessionData> {
  const result = await sendApiRequest<ISessionData>(
    '/schedule',
    {
      method: 'POST',
      body: data,
      headers: {
        'X-User': user.userPseudonym,
        'X-Dealer': user.dealerId,
      },
    },
    true
  );
  if (!result) {
    throw new Error('Failed to create scheduled session');
  }
  return result;
}

/**
 * Update a scheduled session
 */
export async function updateScheduledSession(
  sessionId: string,
  data: Partial<Omit<ISessionData, 'id' | 'dealerId'>>
): Promise<ISessionData> {
  const result = await sendApiRequest<ISessionData>(
    `/schedule/${sessionId}`,
    {
      method: 'PUT',
      body: data,
      headers: {
        'X-User': user.userPseudonym,
        'X-Dealer': user.dealerId,
      },
    },
    true
  );
  if (!result) {
    throw new Error('Failed to update scheduled session');
  }
  return result;
}

/**
 * Delete a scheduled session
 */
export async function deleteScheduledSession(sessionId: string): Promise<void> {
  await sendApiRequest(
    `/schedule/${sessionId}`,
    {
      method: 'DELETE',
      headers: {
        'X-User': user.userPseudonym,
        'X-Dealer': user.dealerId,
      },
    },
    true
  );
}
